import React from 'react';

import { GoogleLogin } from '@react-oauth/google';

import { StyledGoogleSignIn } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('google-sign-in');

const GoogleSignIn = ({ onSuccess, onError, variant = 'full' }) => {
  if (variant === 'icon') {
    return (
      <StyledGoogleSignIn>
        <div className={b('circle-wrapper')}>
          <GoogleLogin onSuccess={onSuccess} onError={onError} type="icon" shape="circle" size="large" />
        </div>
      </StyledGoogleSignIn>
    );
  }

  return (
    <StyledGoogleSignIn>
      <div className={b()}>
        <GoogleLogin onSuccess={onSuccess} onError={onError} text="continue_with" />
      </div>
    </StyledGoogleSignIn>
  );
};

export default GoogleSignIn;
